export const PROJECT_FILES_MAX_BYTES = 100 * 1024 * 1024; // 100 МБ
export const PROJECT_FILES_MAX_SIZE_LABEL = '100 МБ';
export const PROJECT_FILES_MAX_FILENAME_LENGTH = 255;

/** Выше попапа файлов (`usePopoverPositioning` z-index: 1000). */
export const PROJECT_FILES_ROW_CONTEXT_MENU_Z = 1100;

/** Единый ключ для тумблеров фильтра по типу файла во всех попапах файлов сущностей. */
export const PROJECT_FILES_TYPE_FILTER_STORAGE_KEY = 'projectFilesPopover.typeFilter.v1';

/** Меню фильтра по типу — над содержимым попапа и строками. */
export const PROJECT_FILES_TYPE_FILTER_MENU_Z = 1200;

export const NEW_FILE_HOURS_THRESHOLD = 72;
